import React, {PureComponent} from "react"
import styled from "styled-components"

import {FormattedMessage, FormattedCurrency, injectIntl, InjectIntl} from "@irati/utils/lang"
import Card from "@irati/ui/src/Layout/Card"
import {H3,Body} from "@irati/ui/src/Typography"
import {PriceInput, ValidationButton} from "@irati/ui/src/FormItem"
import ErrorText from "@irati/ui/src/ErrorText"
import Validation from "@irati/utils/validation"

const AvailableBalance = styled(H3)`
  color: ${({theme}) => theme.colors.brand.default};
  font-size: 45px;
  line-height: 50px;
  text-align: center;
`

const StyledCaption = styled(Body)`
  text-align: center;
  text-transform: uppercase;
`

const StyledErrorText = styled(ErrorText)`
  margin-top: 15px;
`

interface Props extends InjectIntl {
  wallet: Wallet
  amount: number
  recipients: []
  load: Promise<any> | null
  error: string | null
  onChange: (value: number) => void
  onSubmit: () => void
}

class Sidebar extends PureComponent<Props> {
  render() {
    const {formatMessage, wallet, amount, recipients, load, error, onChange, onSubmit} = this.props
    const {availableBalance, currency} = wallet
    return (
      <Card>
        <StyledCaption small>
          <FormattedMessage id="wallet.sendCredit.availableBalance.title" />
        </StyledCaption>
        <AvailableBalance>
          <FormattedCurrency isCents={false} currency={currency} value={availableBalance} />
        </AvailableBalance>
        <StyledCaption small marginBottom={1}>
          <FormattedMessage id="wallet.sendCredit.availableBalance.footer" />
        </StyledCaption>
        <PriceInput
          currency={wallet.currency}
          label="wallet.sendCredit.amount.label"
          name="SendCreditAmount"
          min="0"
          onChange={onChange}
          step="0.01"
          value={amount}
          validation={Validation.number("platform.defaultValidation.required")
            .min(0.01, "wallet.sendCredit.amount.validation.min")
            .max(Number(availableBalance), "wallet.sendCredit.amount.validation.max")}
        />
        <ValidationButton disabled={recipients.length < 1} primary large full onClick={onSubmit} load={load}>
          {formatMessage({id: "wallet.sendCredit.button"})}
        </ValidationButton>
        {error && <StyledErrorText>{formatMessage({id: error})}</StyledErrorText>}
      </Card>
    )
  }
}

export default injectIntl(Sidebar)
